const API_URL = 'http://localhost:56468/api'; // use this if you're hosting the api locally with visual studios
export default API_URL;
